export const ENV_VARIABLES = {
  baseUrl: process.env.REACT_APP_BASE_URL,
};

export const QUERY_KEYS = {
  USERS: 'Users',
  USER_ROLES: 'User_Roles',
  USER_LIST: 'User_List',
  ADD_USER_FORM_FILEDS: 'Add_User_From_Fields',
  EDIT_USER_FORM_FIELDS: 'Edit_User_From_Fields',
  USER_TYPES: 'User_Type',
  IMPERSONATE_USER: 'Impersonate_User',
  REPORTS_FIELDS: 'REPORTS_FIELDS',
  DRIVERS: 'Drivers',
  ASSIGN_DRIVERS: 'ASSIGN_DRIVERS',
  CREATE_DRIVER: 'Create_Driver',
  EXPORT_DRIVERS: 'Export_Drivers',
  MULTIPLE_UPLOAD_LIST: 'Multiple_Upload_List',
  MULTIPLE_UPLOAD_REPORTS: 'Multiple_Upload_Reports',
  BOOKING_REPORTINGS: 'Booking_Reportings',
  BOOKING_STATISTICS: 'Booking_Statistics',
  OFFER_REPORTING: 'Offer_Reporting',
  DOWNLOAD_LOGS: 'Download_Logs',
  DOWNLOAD_LOGS_DOCUMENT: 'Download_Logs_Document',
  OFFER_LIST: 'Offer_List',
  OFFER_DETAILS: 'Offer_Details',
  CARS: 'Cars',
  SIDEBAR_ITEMS: 'sidebaritems',
  ORDERS: 'Orders',
  INVOICES: 'Invoices',
  IMPORT_TEMPLATE: 'Import_Template',
  NOTIFICATIONS: 'Notifications',
  COMPANY_GROUPS: 'companygroups',
  COMPANY_GROUPS_FIELDS: 'group_Fields',
  COMPANY_GROUPS_EDITABLE_FIELDS: 'group_edit_Fields',
  COMPANY_GROUPS_DETAILS: 'group_details',
  IMPERSONATE_FLEET_ADMIN: 'Impersonate_fleet_admin'
};

export const PAGES = {
  USERS: 'Users',
  ROLES: 'Roles',
  REPORTS: 'Reports',
  INVOICES: 'Invoice',
  IMPORT_DRIVERS: 'Import Drivers',
  MY_CAR: 'My Car',
  DOWNLOAD_LOGS: 'Download Logs',
  OFFER_CHECK: 'Offers Check',
  OFFERS_REPORTING: 'Offers Reporting',
  BOOKING_REPORTS: 'Booking Reporting',
  TRACK_YOUR_CAR: 'Track Your Car',
  GROUP_OF_COMPANIES: 'Company Groups'
};

export const ROLESLIST = {
  CONTRACTCENTER: 'contactCenter',
  FLEETADMIN: 'fleetadmin',
  REPORTSADMIN: 'reportadmin',
  ADMIN: 'admin',
  DOCADMIN: 'docadmin',
  GROUPFLEETADMIN: 'groupfleetadmin' // Double check with backend
};

export const imageStudioBaseUrl =
  'https://cdn.imagin.studio/getImage?customer=avis-gr';

export const myAvisUrl = 'https://www.myavis.gr/el';
